export default __webpack_public_path__ + "static/media/login-bg-FIKA.10421bc6.jpg";